<template>
    <HeaderCardsLayout variant="No-Logo">
        <template #headline>
            {{ $t('event-create') }}
        </template>
        <template #breadcrumb>
            <Breadcrumb :headline="$t('breadcrumb')" :current-page="$t('event-create')">
                <BreadcrumbLink :target="{ name: 'events' }">
                    <BallotIcon class="mr-1 shrink-0" />
                    {{ $t('event-wiki') }}
                </BreadcrumbLink>
                <BreadcrumbLink :target="{ name: 'event-series-overview', params: { seriesId } }">
                    {{ seriesName }}
                </BreadcrumbLink>
            </Breadcrumb>
        </template>
        <template #body>
            <PaddedContentTop>
                <div class="bg-gray-50">
                    <div class="px-4 pb-4 pt-4">
                        <EventCreateForm :series-id="seriesId" />
                    </div>
                </div>
            </PaddedContentTop>
        </template>
    </HeaderCardsLayout>
</template>

<script setup lang="ts">
import Breadcrumb from '@/components/Breadcrumb/Breadcrumb.vue';
import BreadcrumbLink from '@/components/Breadcrumb/BreadcrumbLink.vue';
import BallotIcon from '@/components/Icon/BallotIcon.vue';
import HeaderCardsLayout from '@/components/Layout/HeaderCardsLayout.vue';
import PaddedContentTop from '@/components/Layout/PaddedContentTop.vue';
import { $t } from '@/plugins/fluent';
import { useHeadSafe } from '@unhead/vue';
import EventCreateForm from '../forms/EventCreateForm.vue';

defineProps<{ seriesId: string; seriesName: string }>();

useHeadSafe({ title: () => `${$t('event-create')} - ${$t('event-wiki')}` });
</script>
